export default __webpack_public_path__ + "static/media/add-icon.7eec4158.png";